import request from "./request.service";

export default {
  searchInvites: async function ({
    mobile,
    inviteCode,
    createdFrom,
    createdTo,
    usedFrom,
    usedTo,
  }) {
    try {
      const params = new URLSearchParams();
      if (mobile) params.append("mobile", mobile);
      if (inviteCode) params.append("invite_code", inviteCode);
      if (createdFrom) params.append("created_from", createdFrom);
      if (createdTo) params.append("created_to", createdTo);
      if (usedFrom) params.append("used_from", usedFrom);
      if (usedTo) params.append("used_to", usedTo);

      const response = await request(
        `/referral/invites?${params.toString()}`,
        "GET",
      );
      if (response.data.code === 0) {
        return response.data.data;
      } else {
        throw Error(response.data.message);
      }
    } catch (err) {
      throw err;
    }
  },
  manualApplyInvite: async function (mobile, inviteCode) {
    try {
      const response = await request("/referral/invites/manual-apply", "POST", {
        mobile: mobile,
        invite_code: inviteCode,
      });
      if (response.data.code === 0) {
        return response.data.data;
      } else {
        throw Error(response.data.message);
      }
    } catch (err) {
      throw err;
    }
  },
};
